import { render, staticRenderFns } from "./groupReportCenterTable.vue?vue&type=template&id=1f5e22b0&scoped=true&"
import script from "./groupReportCenterTable.vue?vue&type=script&lang=js&"
export * from "./groupReportCenterTable.vue?vue&type=script&lang=js&"
import style0 from "./groupReportCenterTable.vue?vue&type=style&index=0&id=1f5e22b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5e22b0",
  null
  
)

export default component.exports